import type { PriceAlerts } from '../../types/PriceAlerts';

export const priceAlertsBaseFeatureConfig: PriceAlerts = {
    showNotificationsSettings: false,
};
